/** @jsx jsx */

import { Colors, Link, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { MEDIA_MIN_DESKTOP } from './constants';

const Styles = {
  link: ({
    isActive,
    isLightTheme,
  }: {
    isActive: boolean;
    isLightTheme: boolean;
  }) => css`
    color: inherit !important;
    display: block !important;
    padding: 15px 40px !important;
    text-decoration: none !important;
    width: 100% !important;
    ${[MEDIA_MIN_DESKTOP]} {
      border-bottom: 4px solid
        ${isActive
          ? isLightTheme
            ? Colors.BrandOrange
            : Colors.PrimeWhite
          : 'transparent'} !important;
      margin: 0px 17px !important;
      padding: 21px 3px 17px !important;
      width: initial !important;
      :hover {
        border-bottom-color: ${isLightTheme
          ? Colors.BrandOrange
          : Colors.PrimeWhite} !important;
        color: inherit !important;
      }
    }
  `,
  root: css`
    display: flex;
    list-style: none;
    :hover {
      background-color: ${Colors.UiPrimaryWeakest};
      color: ${Colors.UiPrimaryStrongest};
    }
    ${[MEDIA_MIN_DESKTOP]} {
      display: inline-flex;
      :hover {
        background-color: initial;
        color: inherit;
      }
    }
  `,
};

type NavLink = {
  href: string;
  isVisible: boolean;
  label: string;
};

type Props = {
  currentUrl: string;
  isLightTheme: boolean;
  link: NavLink;
  onClick?: () => void;
};

const defaultProps = {
  linksLeft: undefined,
  onClick: () => undefined,
};

function NavLinkItem({
  currentUrl,
  isLightTheme,
  link,
  onClick = defaultProps.onClick,
}: Props) {
  return (
    <li css={Styles.root} key={link.label}>
      <Link
        css={Styles.link({
          isActive: link.href === currentUrl,
          isLightTheme,
        })}
        href={link.href}
        onPress={() => onClick()}
      >
        <Text color={link.isVisible ? 'inherit' : 'transparent'} type="Body2">
          {link.label}
        </Text>
      </Link>
    </li>
  );
}

NavLinkItem.defaultProps = defaultProps;

export default NavLinkItem;
